import type {DocumentationBreakpoint} from './useDocumentationBreakpoint';

const COLUMNS_BY_BREAKPOINT: Record<DocumentationBreakpoint, string[]> = {
  compact: ['documentDescription', 'actions'],
  narrow: ['dateOfService', 'member', 'staff', 'statusBadge', 'actions'],
  medium: [
    'dateOfService',
    'member',
    'staff',
    'sessionType',
    'status',
    'actions',
  ],
  wide: [
    'dateOfService',
    'member',
    'staff',
    'sessionType',
    'typeOfService',
    'status',
    'actions',
  ],
};

type Options = {
  showMyDocuments: boolean;
};

export const getSessionDocumentsTabColumns = (
  breakpoint: DocumentationBreakpoint,
  {showMyDocuments}: Options,
): string[] => {
  const columns = COLUMNS_BY_BREAKPOINT[breakpoint];

  return showMyDocuments
    ? columns.filter((column) => column !== 'staff')
    : columns;
};
